// extracted by mini-css-extract-plugin
module.exports = {"visible":"visible-2NXNj","invisible":"invisible-3JVe0"};